(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["creator-rewards-dashboard"] && !Shopify.designMode) return;
  try {
    (function () {
    var PROXY = '/apps/members';

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function init() {
      var root = document.querySelector('[data-cr-root]');
      if (!root) return;

      var currency = root.getAttribute('data-cr-currency') || '£';
      var currencyCode = root.getAttribute('data-cr-currency-code') || '';
      var showCode = root.getAttribute('data-cr-show-code') === '1';

      var currentEl = root.querySelector('[data-cr-current]');
      var earnedEl = root.querySelector('[data-cr-earned]');
      var listEl = root.querySelector('[data-cr-list]');
      var formEl = root.querySelector('[data-cr-form]');
      var fileEl = root.querySelector('[data-cr-file]');
      var fileBtn = root.querySelector('[data-cr-file-btn]');
      var fileNameEl = root.querySelector('[data-cr-file-name]');
      var submitEl = root.querySelector('[data-cr-upload-btn]');
      var authEl = root.querySelector('[data-cr-auth]');
      var termsEl = root.querySelector('[data-cr-terms]');
      var filtersEl = root.querySelector('[data-cr-filters]');
      var allUploads = [];
      var timeFilter = '7';
      var statusFilter = 'all';
      var progWrap = root.querySelector('[data-cr-progress]');
      var progBar = root.querySelector('[data-cr-progress-bar]');
      var statusEl = root.querySelector('[data-cr-status]');
      var modalEl = root.querySelector('[data-cr-modal]');
      var modalCloseEl = root.querySelector('[data-cr-modal-close]');

      function fmt(n) {
        n = Number(n) || 0;
        return n % 1 === 0 ? String(n) : n.toFixed(2);
      }

      function money(n) {
        var out = currency + fmt(n);
        if (showCode && currencyCode) out += ' ' + currencyCode;
        return out;
      }

      function badge(status) {
        var map = { pending: 'Uploading', uploaded: 'In review', approved: 'Approved', rejected: 'Not accepted' };
        return map[status] || status;
      }

      function itemHtml(u) {
        var reward = u.reward_amount ? ' · ' + money(u.reward_amount) : '';
        var when = '';
        if (u.created_at) {
          try {
            when = ' · ' + new Date(u.created_at).toLocaleDateString();
          } catch (e) {}
        }
        return (
          '<li class="cr-item cr-item--' +
          u.status +
          '">' +
          '<span class="cr-item__name">' +
          escapeHtml(u.filename) +
          '</span>' +
          '<span class="cr-item__meta">' +
          badge(u.status) +
          reward +
          when +
          '</span>' +
          '</li>'
        );
      }

      function renderList() {
        if (!listEl) return;
        if (!allUploads.length) {
          listEl.innerHTML = '<li class="cr-empty">No uploads yet — share your first piece above.</li>';
          return;
        }
        var now = Date.now();
        var maxAge = timeFilter === 'all' ? null : Number(timeFilter) * 86400000;
        var filtered = allUploads.filter(function (u) {
          if (statusFilter !== 'all' && u.status !== statusFilter) return false;
          if (maxAge && u.created_at) {
            var t = new Date(u.created_at).getTime();
            if (!isNaN(t) && now - t > maxAge) return false;
          }
          return true;
        });
        listEl.innerHTML = filtered.length
          ? filtered.map(itemHtml).join('')
          : '<li class="cr-empty">Nothing matches these filters.</li>';
      }

      function renderSession(data) {
        if (currentEl) currentEl.textContent = money(data.currentBalance);
        if (earnedEl) earnedEl.textContent = money(data.earnedTotal);
        allUploads = data.uploads || [];
        renderList();
      }

      function loadSession() {
        fetch(PROXY + '/session', { headers: { Accept: 'application/json' } })
          .then(function (r) {
            return r.json();
          })
          .then(renderSession)
          .catch(function () {});
      }

      function setStatus(msg) {
        if (statusEl) statusEl.textContent = msg || '';
      }

      function setProgress(frac) {
        if (!progWrap || !progBar) return;
        if (frac == null) {
          progWrap.hidden = true;
          progBar.style.width = '0';
          return;
        }
        progWrap.hidden = false;
        progBar.style.width = Math.round(frac * 100) + '%';
      }

      function collectMeta() {
        var meta = {};
        var fields = root.querySelectorAll('[data-cr-field]');
        for (var i = 0; i < fields.length; i++) {
          meta[fields[i].getAttribute('data-cr-field')] = fields[i].value || '';
        }
        meta.authorised = authEl ? authEl.checked : false;
        meta.termsAgreed = termsEl ? termsEl.checked : false;
        meta.currency = formEl ? formEl.getAttribute('data-cr-currency-code') || '' : '';
        meta.customerName = formEl ? formEl.getAttribute('data-cr-customer-name') || '' : '';
        meta.customerEmail = formEl ? formEl.getAttribute('data-cr-customer-email') || '' : '';
        return meta;
      }

      function upload(file) {
        if (!file) return;
        var meta = collectMeta();
        if (!meta.authorised || !meta.termsAgreed) {
          setStatus('Please tick both boxes before uploading.');
          return;
        }

        var contentType = file.type || 'application/octet-stream';
        submitEl.disabled = true;
        setStatus('Preparing upload…');
        setProgress(0);

        var body = {};
        for (var k in meta) {
          if (Object.prototype.hasOwnProperty.call(meta, k)) body[k] = meta[k];
        }
        body.filename = file.name;
        body.contentType = contentType;
        body.sizeBytes = file.size;

        fetch(PROXY + '/upload-url', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (data) {
            if (!data.uploadUrl) throw new Error('no_url');
            return new Promise(function (resolve, reject) {
              var xhr = new XMLHttpRequest();
              xhr.open('PUT', data.uploadUrl);
              xhr.setRequestHeader('Content-Type', contentType);
              xhr.upload.onprogress = function (e) {
                if (e.lengthComputable) setProgress(e.loaded / e.total);
              };
              xhr.onload = function () {
                if (xhr.status >= 200 && xhr.status < 300) {
                  resolve(data);
                } else {
                  reject(new Error('put_' + xhr.status));
                }
              };
              xhr.onerror = function () {
                reject(new Error('network'));
              };
              setStatus('Uploading ' + file.name + '…');
              xhr.send(file);
            });
          })
          .then(function (data) {
            setStatus('Finishing…');
            return fetch(PROXY + '/complete', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ uploadId: data.uploadId }),
            });
          })
          .then(function () {
            setStatus('');
            setProgress(null);
            if (formEl) formEl.reset();
            if (fileNameEl) fileNameEl.textContent = '';
            loadSession();
            if (modalEl && modalEl.showModal) {
              try { modalEl.showModal(); } catch (e) { setStatus('Uploaded — it is now in review. Thank you!'); }
            } else {
              setStatus('Uploaded — it is now in review. Thank you!');
            }
          })
          .catch(function (err) {
            if (window.console) console.error(err);
            setStatus('Sorry, that upload failed. Please try again.');
            setProgress(null);
          })
          .then(function () {
            submitEl.disabled = false;
          });
      }

      if (fileBtn && fileEl) {
        fileBtn.addEventListener('click', function () {
          fileEl.click();
        });
        fileEl.addEventListener('change', function () {
          if (fileNameEl) fileNameEl.textContent = fileEl.files && fileEl.files.length ? fileEl.files[0].name : '';
        });
      }

      if (formEl) {
        formEl.addEventListener('submit', function (e) {
          e.preventDefault();
          if (!fileEl || !fileEl.files || !fileEl.files.length) {
            setStatus('Please choose a file to upload.');
            return;
          }
          upload(fileEl.files[0]);
        });
      }

      if (modalEl) {
        if (modalCloseEl) modalCloseEl.addEventListener('click', function () { modalEl.close(); });
        modalEl.addEventListener('click', function (e) { if (e.target === modalEl) modalEl.close(); });
      }

      if (filtersEl) {
        filtersEl.addEventListener('click', function (e) {
          var btn = e.target.closest('.cr-filter');
          if (!btn) return;
          var t = btn.getAttribute('data-cr-time');
          var s = btn.getAttribute('data-cr-status');
          if (t !== null) timeFilter = t;
          if (s !== null) statusFilter = s;
          var siblings = btn.parentNode.querySelectorAll('.cr-filter');
          for (var i = 0; i < siblings.length; i++) siblings[i].classList.remove('is-active');
          btn.classList.add('is-active');
          renderList();
        });
      }

      loadSession();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
